// extracted by mini-css-extract-plugin
export default {"columnHeader":"styles-module__columnHeader__src-labstep-web-grid-Index-coldefs-ProtocolValue-Header-_GpL9H"};